import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import CoverImage from './CoverImage';
import { uploadReportImage } from '../../../services/saleReport/saleReportService';
import legacy from '../../../utils/legacy';
import styles from '../SaleReportPage.module.scss';

const DocumentIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <path d="M4 8h16" />
    <path d="M9 14h6" />
  </svg>
);

function CoverSection({ config, sale, photos, agent, onChange }) {
  const [uploading, setUploading] = useState(false);
  const fields = config.fields || {};

  const setField = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key]: val } });
  };

  // 표지 이미지: 업로드한 게 있으면 그것, 아니면 매물 1번 사진
  const firstPhoto = photos && photos.length > 0 ? photos[0] : null;
  const coverPhotoUrl = config.coverPreview || (firstPhoto ? (firstPhoto.full || firstPhoto.thumb) : null);

  return (
    <>
      <SectionHeader
        icon={<DocumentIcon />}
        title="표지 구성"
        locked="필수 영역"
      />
      <div className={styles.grid}>
        <Field label="매물명 / 표지 제목" span={12} required>
          <input
            type="text"
            value={config.title || ''}
            onChange={(e) => onChange({ ...config, title: e.target.value })}
            placeholder={sale?.address || ''}
          />
        </Field>

        <Field
          label="표지 주소"
          span={12}
          toggle
          toggleEnabled={fields.cover_address !== false}
          onToggle={(v) => setField('cover_address', v)}
        >
          <input
            type="text"
            value={fields.cover_address_edit !== undefined ? fields.cover_address_edit : (sale?.address || '')}
            onChange={(e) => setField('cover_address_edit', e.target.value)}
          />
        </Field>

        <Field label="표지 대표 이미지" span={12}>
          <CoverImage
            photoUrl={coverPhotoUrl}
            uploading={uploading}
            onUpload={async (file) => {
              setUploading(true);
              try {
                const key = await uploadReportImage(file);
                const base = legacy.server_by_hostname('aurora', 'files/sale_photo/');
                onChange({
                  ...config,
                  coverKey: key,
                  coverPreview: base + key,
                });
              } catch (err) {
                console.error('Cover upload failed:', err);
                alert('이미지 업로드에 실패했습니다.');
              } finally {
                setUploading(false);
              }
            }}
            onReset={config.coverKey ? () => {
              onChange({ ...config, coverKey: null, coverPreview: null });
            } : undefined}
          />
        </Field>
      </div>
    </>
  );
}

export default CoverSection;
